import React from "react";

import MenuLink from "@components/MenuLink";

import { useLocale } from "@context/locale";

import NAVIGATION from "@constants/pl/navigation";
import NAVIGATION_EN from "@constants/en/navigation";

import "./styles.scss";

function Navigation() {
  const { lang } = useLocale();
  const navigation_list = lang === "en" ? NAVIGATION_EN : NAVIGATION;

  return (
    <nav className="navigation">
      {navigation_list.map((item) => <MenuLink {...item} />)}
    </nav>
  );
}

export default Navigation;
